import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {IRootState} from "./configureStore";
import {IFile} from "./sliceFiles";
import {stat} from "fs";

export interface IVideo {
  token: string;
  expiredTime: string;
}

export const initialState = {
  video: {} as IVideo
};


const slice = createSlice({
  name: 'video',
  initialState,
  reducers: {
    setVideo: (state: IRootState, action: PayloadAction<IVideo>) => {
      state.user = action.payload
    },
    clearVideo: (state: IRootState) => {
      state.video = {} as IVideo
    },
  },
});

const { actions, reducer } = slice;

export { actions, reducer };
